import "./index.css"
import "./mobile.css"

function BackButton(props) {
    return  <div className="back-button" style={{backgroundColor:props.color}}><img src="./icons/back.png" alt="small back button"></img></div>;
  }

export default BackButton;
